import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { castArray } from 'lodash';
import React from 'react';

import { strommeboxLeftPictureProps } from 'src/resources/picture';

import {
  StyledContent,
  StyledCard,
  StyledDescription,
  StyledModellAImage,
  StyledTitle,
} from './product-select-card.styled';

interface Props {
  onButtonClick: () => void;
  buttonText: string;
  title: string;
  descriptions: string[] | string;
}

export const ProductSelectCard: React.FC<Props> = (props) => {
  const { title, descriptions, ...rest } = props;

  const renderDescriptions = () =>
    castArray(descriptions).map((description, index) => (
      <StyledDescription variant="uiText3" component="p" maxBreakpoint={Breakpoint.TABLET} key={index}>
        {description}
      </StyledDescription>
    ));

  return (
    <StyledCard {...rest}>
      <StyledContent>
        <StyledModellAImage {...strommeboxLeftPictureProps} />
        <StyledTitle variant="paragraph1" component="p" maxBreakpoint={Breakpoint.TABLET}>
          {title}
        </StyledTitle>
        {renderDescriptions()}
      </StyledContent>
    </StyledCard>
  );
};
